(function () {
    'use strict';

    angular.module("imApp").factory("rfidSearchService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1771,
                    parameters: parms || {}
                });
            },
            listRfids: function (parms) {
                return $ihttp.post({
                    method: 1772,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
